import { forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import cx from "clsx";

type TextInputProps = InputHTMLAttributes<HTMLInputElement>;

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => {
    return (
      <input
        {...props}
        className={twMerge(
          cx(
            "text-input block w-full max-w-lg p-2 focus:outline-none",
            props.className,
          ),
        )}
        ref={ref}
      />
    );
  },
);

TextInput.displayName = "TextInput";
